import { Link } from 'react-router-dom'
import { categories } from '@/mocks/categories'
import ScrollReveal from '@/components/base/ScrollReveal'

export default function CategorySection() {
  return (
    <section className="py-16 md:py-24 bg-background-100" aria-labelledby="category-title">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">

        <ScrollReveal direction="up" className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 border border-foreground-300 rounded-full text-xs font-medium text-foreground-600 mb-4">
            分类导航
          </span>
          <h2 id="category-title" className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            探索多元漫画宇宙
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            Romance · Action · Fantasy · BL · Thriller · Drama · Comedy · Historical · School Life
          </p>
        </ScrollReveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <ScrollReveal
              key={cat.slug}
              direction="up"
              delay={index * 60}
              duration={550}
            >
              <Link
                to={`/category/${cat.slug}`}
                className="group bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col items-center text-center transition-all duration-400 ease-out hover:bg-primary-500 hover:-translate-y-1.5 hover:shadow-[0_8px_30px_-6px_oklch(var(--primary-500)/0.3)] active:translate-y-0 active:shadow-none cursor-pointer"
              >
                <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-background-100 text-foreground-600 group-hover:bg-background-50/20 group-hover:text-background-50 group-hover:scale-110 transition-all duration-400 ease-out mb-3">
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </span>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-background-50 transition-colors duration-300 mb-1 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 group-hover:text-background-50/80 transition-colors duration-300 mb-3 line-clamp-2">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-400 group-hover:text-background-50/70 transition-colors duration-300">
                  {cat.count.toLocaleString()}部作品
                </span>
              </Link>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  )
}